import React from "react";
import Icons from "../../../Icons/Icons";
import { isSet } from "../../../../Utils/CommonFunctions";

const TableHead = (props)=>{
    const {tableHead,sortHandler,rowsSelectedCount,tableData,changeHandler,storageSelectionMode,orderBy,direction} = props;
    let tableHeader = [];
    tableHead.map((header,index)=>{
        let styles = isSet(header.styles,{});
        if(header.type==='RadioButton' || header.type==='Checkbox'){
            styles={
                ...styles,
                width:'20px'
            }
        }

        //Sorting Handler
        let thEventHandler ={}
        const isSelectionColumn = storageSelectionMode === true
            && (header.type==='RadioButton' || header.type==='Checkbox' || header.type==='GridActionWithCheckBox');
        if(isSelectionColumn){
            thEventHandler = {};
        }else if(header.clickHandler!==undefined && header.clickHandler!==''&& (tableData && tableData.data)?tableData.data.length!==0:''){
            thEventHandler ={
                onClick:header.clickHandler
            }
        }else {
            thEventHandler ={
                onClick:sortHandler.bind(this,header)
            }
        }
        if(header.isShow && header.isShow===true){
            const headerSelectHandler = (event) => {
                if (storageSelectionMode === true && event && event.stopPropagation) {
                    event.stopPropagation();
                }
                if (header.changeHandler) {
                    header.changeHandler(rowsSelectedCount);
                    return;
                }
                if (changeHandler) {
                    changeHandler(rowsSelectedCount);
                }
            };
            const isStorageCheckHeader = storageSelectionMode === true
                && header.attributes
                && header.attributes.className
                && String(header.attributes.className).indexOf('ship-storage-th-check') !== -1;
            const isActiveSortColumn = header.isSort === true
                && header.sortName
                && orderBy
                && String(orderBy) === String(header.sortName);
            let sortIconType = '';
            let sortIconColor = '#94a3b8';
            if (header.isSort === true && header.sortName) {
                if (isActiveSortColumn) {
                    sortIconType = direction === 'ASC' ? 'asc' : 'desc';
                    sortIconColor = '#1e40af';
                }
            }
            const ariaSort = header.isSort === true && header.sortName
                ? (isActiveSortColumn ? (direction === 'ASC' ? 'ascending' : 'descending') : 'none')
                : undefined;
            tableHeader.push(
            <th className="thWidth" style={styles} key={index} aria-sort={ariaSort} {...thEventHandler}  {...header.attributes}> 
                <span className=""> 
                    {header.name}
                    {(header.type==='GridActionWithCheckBox' || header.type ==='Checkbox')?
                        <label  style={{
                            padding: '5px 12px',     // makes it span full width
                            height: '100%',        // lets it fill the <th> vertically
                            margin: 0,             // remove default inline-label margins
                            cursor: 'pointer'      // whole area is clickable
                                }}
                            onClick={storageSelectionMode === true ? (event) => {
                                if (event && event.stopPropagation) {
                                    event.stopPropagation();
                                }
                            } : undefined}> 
                        <input 
                            onChange={storageSelectionMode === true
                                ? headerSelectHandler
                                : ((header.changeHandler) ?header.changeHandler.bind(this,rowsSelectedCount):changeHandler.bind(this,rowsSelectedCount))}
                            onClick={storageSelectionMode === true ? (event) => {
                                if (event && event.stopPropagation) {
                                    event.stopPropagation();
                                }
                            } : undefined}
                            className={isStorageCheckHeader
                                ? 'ship-storage-file-check ship-storage-file-check--all'
                                : 'form-radio-input m-2'}
                            type="checkbox"
                            name="checkbbox"
                            aria-label={isStorageCheckHeader ? 'Select all files on this page' : undefined}
                            checked={storageSelectionMode === true && header.checked !== undefined
                                ? (header.checked === true)
                                : (rowsSelectedCount===0)?true:false} /> 
                        </label>
                    :<></>}
                   
                </span> 
                {(header.isSort && header.isSort===true)?
                    <span className="position-absolute icon-right mr-2 ship-storage-th-sort-icon" style={{marginTop:'12px'}} > 
                        <Icons iconType="TableSort" type={sortIconType} color={sortIconColor} />
                    </span> 
                :<></>}
                
            </th>);
        }
        return header;
    });
    return(
        <thead className={props.tHeadClassName}>
            <tr key={'tableHeader'}>{tableHeader}</tr>
        </thead> 
    )
}
TableHead.defaultProps={
    tHeadClassName:'table_tHeadBg',
    storageSelectionMode: false
}

export default TableHead;
